import { combineReducers } from "redux";
import a7ProductsReducer from "./a7products/A7ProductsReducer";
import adminGroupReducer from "./adminGroups/AdminGroupReducer";
import basketReducer from "./basket/BasketReducer";
import countriesReducer from "./countries/CountriesReducer";
import downloadCentreFileReducer from "./downloadCentreFiles/DownloadCentreFileReducer";
import emptyOrderFilesReducer from "./emptyOrderFiles/EmptyOrderFilesReducer";
import errorReducer from "./error/ErrorReducer";
import filesInfoReducer from "./filesInfo/FilesInfoReducer";
import kaikoReducer from "./filterableProducts/kaiko/KaikoReducer";
import internalUserReducer from "./internal/InternalUserReducer";
import orderReducer from "./orders/OrderReducer";
import creditCardReducer from "./payment/CreditCardReducer";
import productFileReducer from "./productFiles/ProductFileReducer";
import productsReducer from "./products/ProductsReducer";
import publicLinkReducer from "./publicLinks/PublicLinkReducer";
import quotaReducer from "./quotas/QuotaReducer";
import requestingReducer from "./requesting/RequestingReducer";
import statisticsReducer from "./statistics/StatisticsReducer";
import subscriptionReducer from "./subscriptions/SubscriptionReducer";
import taskReducer from "./tasks/TaskReducer";
import toastsReducer from "./toasts/ToastsReducer";
import userDetailsReducer from "./user/UserDetailsReducer";
import filterableSubscriptionReducer from "./filterableSubscriptionRequests/FilterableSubscriptionRequestReducer";
import useCasesReducer from "./useCases/UseCasesReducer";
import singleIsinReportReducer from "./reports/singleIsin/SingleIsinReportReducer";
import contractReducer from "./contracts/ContractReducer";
import businessPartnerReducer from "./businessPartners/BusinessPartnerReducer";

export default function rootReducer() {
    return combineReducers({
        basket: basketReducer,
        error: errorReducer,
        requesting: requestingReducer,
        filesInfo: filesInfoReducer,
        orders: orderReducer,
        tasks: taskReducer,
        toasts: toastsReducer,
        subscriptions: subscriptionReducer,
        filterableSubscriptionRequests: filterableSubscriptionReducer,
        userDetails: userDetailsReducer,
        internalUser: internalUserReducer,
        countries: countriesReducer,
        donwloadCentreFiles: downloadCentreFileReducer,
        adminGroups: adminGroupReducer,
        payment: creditCardReducer,
        products: productsReducer,
        a7products: a7ProductsReducer,
        productFiles: productFileReducer,
        quotas: quotaReducer,
        publicLinks: publicLinkReducer,
        statistics: statisticsReducer,
        emptyOrder: emptyOrderFilesReducer,
        kaiko: kaikoReducer,
        useCases: useCasesReducer,
        singleIsinsReports: singleIsinReportReducer,
        contracts: contractReducer,
        businessPartners: businessPartnerReducer
    });
}
